@let balanceInfo = balanceInfoWithLoadingStatus()?.balanceInfo;

<div class="block-wrapper">
  <button
    type="button"
    class="link balance"
    dataAttribute
    componentName="header-user-info-balance-link"
    [attr.aria-label]="'HEADER_USER_INFO.BALANCE_DETAILS' | transloco"
    (click)="onBalanceDetailsClick($event, balanceDetailsPopover)"
  >
    <div class="balance__text">
      <b2b-portal-tiss-icon
        class="balance__icon"
        iconId="balance"
        size="small"
      ></b2b-portal-tiss-icon>
    </div>

    <span
      class="text--semi"
      [class.color--danger]="(balanceInfo?.balance || 0) < 0"
      data-component="header-user-info-balance-label"
      [attr.data-value]="balanceInfo ? (balanceInfo.balance | currencyFormatter) : null"
    >
      @if (balanceInfo) {
        {{
          balanceInfo.balance
            | currencyFormatter: { formatOptions: balanceCurrencyFormat }
        }}
      } @else {
        —
      }
    </span>
  </button>

  @let paymentTypes = cardPaymentTypes$ | async;
  @if ((paymentTypes?.length || 0) > 0) {
    <ng-container *showOnPlatformNarrow="Platform.Desktop">
      <p-button
        text
        rounded
        icon="pi pi-wallet"
        styleClass="balance-payment-button"
        [ariaLabel]="'PAYMENT_TYPES.BALANCE' | transloco"
        dataAttribute
        componentName="header-user-info-make-payment-button"
        (onClick)="makePaymentBalance()"
      />
    </ng-container>
  }

  <ng-container *showOnPlatformNarrow="[Platform.Tablet, Platform.Desktop]">
    <a
      class="body link overdue"
      [routerLink]="ROUTES.DEBTS"
      dataAttribute
      componentName="header-user-info-debts-link"
    >
      <div class="overdue__text">
        <b2b-portal-tiss-icon
          class="overdue__icon"
          iconId="pdz"
          size="small"
        ></b2b-portal-tiss-icon>
      </div>
      <span class="text--semi" [class.color--danger]="(balanceInfo?.debt || 0) > 0">
        @if (balanceInfo) {
          {{ balanceInfo.debt | currencyFormatter }}
        } @else {
          —
        }
      </span>
    </a>
    @if (canDisplayBonus) {
      <a
        class="body link bonus"
        [routerLink]="bonusLink"
        dataAttribute
        componentName="header-user-info-loyalties-link"
      >
        <b2b-portal-tiss-icon
          class="bonus__icon"
          iconId="bonus"
          size="small"
        ></b2b-portal-tiss-icon>

        <span class="text--semi bonus__text">
          {{ balanceInfo?.bonusActive | empty }}
        </span>
      </a>
    }
  </ng-container>
</div>

<p-popover
  #balanceDetailsPopover
  dismissable
  [focusOnShow]="false"
  styleClass="balance-details-popover header-popover"
>
  <ng-template pTemplate="content">
    @if (balanceDetailsComponent(); as detailsComponent) {
      <ng-container
        *ngComponentOutlet="
          detailsComponent;
          inputs: getBalanceDetailsInputs(balanceDetailsPopover)
        "
      />
    }
  </ng-template>
</p-popover>
